export * from './change-password.component';
// export * from './reset-password.modoule';
export * from './change-password.service';



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/change-password/index.ts